import React, { useRef, useEffect } from 'react'
import { translate } from '../../../../../../../utils/language'
import { debounce } from 'lodash'
function HexColor({ setItem, value, id, targetKey, options, componentType, isWidgetItem, hideBorder }) {
    const ref = useRef()
    const textRef = useRef()
    useEffect(() => {
        if (ref.current && value)
            ref.current.value = value
        if (textRef.current)
            textRef.current.value = value
    }, [id])


    const delayedSetItem = debounce((event, key) => {
        if (textRef.current)
            textRef.current.value = event.target.value
        setItem(event?.target?.value, key);
    });
    return (
        <div className={`w-[100%] text-left py-2 ${hideBorder ? "" : "border-b-1"}`}  >
            <div className='flex justify-between py-0 w-[100%] items-center'>
                <p className='text-sm py-2 text-[#8A92A6] text-[15px] font-medium shrink-1 overflow-hidden break-words'>{translate(`${componentType}.${targetKey}`)}</p>
                <div className='flex items-center border-1 rounded box-border p-1 shrink-0'>
                    <input
                        type="color"
                        ref={ref}
                        onChange={(event) => { delayedSetItem(event, targetKey) }}
                    />
                    <input type="text" ref={textRef} className='text-[#8A92A6] text-[14px] w-[65px] pl-1' onChange={(e) => {
                        // let validValue = e.target.value
                        // if (value?.length === 9) {
                        //     validValue = validValue.substring(0, 6)
                        // }
                        // const isValidHex = (/^#[0-9A-F]{6}$/i).test(validValue);
                        // if (!isValidHex) return
                        // SEYFULLAH TRANSPARENT ISTEDI

                        ref.current.value = e?.target?.value
                        if (!e.target.value) return
                        delayedSetItem(e, targetKey)
                    }} />
                </div>
            </div>
        </div>
    )
}

export default HexColor